<template>
  <div class="page_all">
    <loading
      :active.sync="isLoading"
      :on-cancel="onCancel"
      :is-full-page="fullPage"></loading>
    <div class="return_link">
      <router-link to="/setting">＞ 設定</router-link>
    </div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">お問い合わせ</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_group">お問い合わせ設定</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="td_content_top">
              <div class="top_index">
                  <div class="notes">
                    <p class="notes_p">こちらはアプリ上にある「お問い合わせ」機能の設定になります。</p>
                    <p class="notes_p">設定したメールアドレスは、メーラーを起動した際の宛先に設定されます。</p>
                    <p class="notes_p">また、メッセージを設定している場合は、メーラーの起動前にダイアログメッセージを表示します。</p>
                  </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle">
              <div class="index_name">メールアドレス</div>
              <div>
                <input type="text" class="input_email" v-model.trim="$v.inquiry_email.$model" />
              </div>
              <div class="message">
                <div v-if="$v.inquiry_email.$dirty">
                  <div class="error" v-if="!$v.inquiry_email.maxLength">メールアドレスの長さは最高{{ $v.inquiry_email.$params.maxLength.max }}文字以下です。</div>
                  <div class="error" v-if="!$v.inquiry_email.email">不正なメールアドレスです。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle">
              <div class="index_name">メッセージ</div>
              <div>
                <textarea type="text" class="input_message" v-model.trim="$v.inquiry_message.$model" />
              </div>
              <div class="message">
                <div v-if="$v.inquiry_message.$dirty">
                  <div class="error" v-if="!$v.inquiry_message.maxLength">メッセージの長さは最高{{ $v.inquiry_message.$params.maxLength.max }}文字以下です。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_bottom">
              <button class="btn_general" :disabled="$v.$invalid" @click="contactUpdate">更新</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { maxLength, email } from 'vuelidate/lib/validators'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    "loading":Loading
  },
  data: function() {
    return {
        inquiry_email: null,
        inquiry_message: null,
        // メッセージ
        message: "",

        isLoading: false,
        fullPage: true      
    }
  },
	mounted() {
    this.contactDetail()
  },
  methods: {
    async contactDetail() {
      try {
        const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'contact/detail', {
          params: {
            municipality_key: this.$store.getters.getStateMunicipalityKey
          }
        })
        console.log(response.data)
        this.inquiry_email = response.data.municipality[0].contact_email
        this.inquiry_message = response.data.municipality[0].contact_message
        this.message = ""

      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async contactUpdate() {
      this.isLoading = true
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'contact/update', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          contact_email: this.inquiry_email,
          contact_message: this.inquiry_message
        })
        this.message = ""
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
      this.isLoading = false
      
      this.contactDetail()
    },
    onCancel:function() {
      console.log('User cancelled the loader.')
    },
  },
    validations: {
        inquiry_email: {
            maxLength: maxLength(250),
            email
        },
        inquiry_message: {
            maxLength: maxLength(500),
        },
  }
}
</script>

<style scoped>
table th.th_group {
  text-align: left;
  padding-left: 10px;
}
table tr {
  border: none;
}
table td.td_content_top {
  display: flex;
  border: none;
  padding: 20px 20px 20px 20px;
}
table td.td_content_middle {
  text-align: left;
  border: none;
  padding: 0px 20px 0px 20px;
}
table td.td_content_bottom {
  text-align: center;
  border: none;
  padding: 0px 0px 0px 20px;
}
.top_index {
  width: 100%;
  padding: 0px 0px 5px 0px;
  border-bottom: 1px solid dimgray;
}
.index_name {
  width: 100%;
  margin: 0 20px 0 0;
  padding: 0px 0px 5px 0px;
}
.btn_general {
  margin: 20px 0 20px 0;
  width: 80px;
}
.notes {
    text-align: left;
    width: 100%;
}
.notes_p {
    font-size: smaller;
    line-height: 0.4;
}
.input_email {
    width: 300px;
}
.input_message {
    width: 100%;
    height: 100px;
}
</style>